import { render, staticRenderFns } from "./ThirdPartyAPI.vue?vue&type=template&id=513d215e&scoped=true"
import script from "./ThirdPartyAPI.vue?vue&type=script&lang=js"
export * from "./ThirdPartyAPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513d215e",
  null
  
)

export default component.exports